var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudStorage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_5702)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5036 12.4551H6.49638V24.379H19.5036V12.4551ZM18.413 13.5456V23.2884H7.58693V13.5456H18.413Z",
    fill: "#002852"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 16.2536H16.7917V15.1631H14.625V16.2536Z",
    fill: "#002852"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 21.6706H16.7917V20.5801H14.625V21.6706Z",
    fill: "#002852"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.71214C15.4971 2.71214 17.7522 4.39679 18.3932 6.64943L18.5059 7.04547H19.5C22.4895 7.04547 24.913 9.46905 24.913 12.4585C24.913 15.448 22.4895 17.8716 19.5 17.8716V18.4169V18.9621C23.0918 18.9621 26.0036 16.0503 26.0036 12.4585C26.0036 8.86675 23.0918 5.95492 19.5 5.95492H19.3144C18.3971 3.41777 15.8158 1.62158 13 1.62158C9.59185 1.62158 6.7959 4.24328 6.51891 7.57991H5.68748C2.54259 7.57991 -0.00362778 10.1261 -0.00362778 13.271C-0.00362778 16.4159 2.54259 18.9621 5.68748 18.9621H19.5C19.5001 18.9621 19.5 18.9621 19.5 18.4169C19.5 17.8716 19.5001 17.8716 19.5 17.8716H5.68748C3.14488 17.8716 1.08693 15.8136 1.08693 13.271C1.08693 10.7284 3.14488 8.67047 5.68748 8.67047H7.58693V8.12519C7.58693 5.13572 10.0105 2.71214 13 2.71214Z",
    fill: "#002852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_5702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "matrix(-1 0 0 1 26 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudStorage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud_storage.6f94404fb92b74a80606e0e1b2a20783.svg";